import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser, removeUser } from "@utils";
import { updateLastAuthTime } from "../utils/authStorage";

export const authManagementApi = createApi({
	reducerPath: "authManagementApi",
	refetchOnFocus: false,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: false,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["auth-api"],
	}),
	endpoints: (builder) => ({
		reAuth: builder.mutation({
			query: (usernameParam) => {
				const user = getUser();
				const username = (usernameParam || user?.username || "").toLowerCase();

				return {
					url: "/re-auth",
					method: "POST",
					body: { username },
				};
			},
			async onQueryStarted(arg, { queryFulfilled }) {
				try {
					await queryFulfilled;
					updateLastAuthTime();
					window.dispatchEvent(new CustomEvent("auth-revalidated"));
				} catch (error) {
					const status = error?.error?.status;
					if (status === 400 || status === 401) {
						removeUser();
						window.dispatchEvent(new CustomEvent("userLogout"));
						window.location.href = "/";
					}
				}
			},
		}),
		socialLogin: builder.mutation({
			query: (payload) => ({
				url: "/login/social/token",
				method: "POST",
				body: payload,
				credentials: "include",
			}),
		}),
	}),
});

export const { useReAuthMutation, useSocialLoginMutation } = authManagementApi;
